module.exports = __webpack_public_path__ + "static/media/airlines.8712aa24.svg";